var up = "https://shopfront-cdn.tekoapis.com/static/91d02f8bbc1b94f9.svg";

export { up as default };
